import React from "react";
import styled from "styled-components";

export const Container = styled.div`
	margin: ${props => props.theme.spacing};
	max-width: ${props => props.theme.max};
    @media(max-width: 767px){
		margin:  ${(props) => props.theme.mobileSpacing};
	}
`;

export const ProductTitle = styled.p`
    color: #070808;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 16px;
    padding-left: 16px;
    margin-top: 0;
    @media (max-width: 767px){
        min-height: 32px;
    }
`;

export const ProductBrand = styled.p`
    color: #999999;
    font-family: Mallory;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 12px;
    padding-left: 16px;
    margin-bottom: 4px;
`;

export const ProductImage = styled.img`
    height: 346px;
    width: 346px;
    @media (max-width: 767px){
        height: 157px;
        width: 157px;
    }
`;

export const ProductPrice = styled.p`
    color: #747474;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 17px;
    padding-left: 16px;
    margin-bottom: 32px;
`;

export const FlexRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    margin: auto;
    max-width: 1150px;
    @media (max-width: 767px){
        display: none;
    }
`;

export const Column = styled.div`
    flex: 0 1 33%;
    padding: 0 16px;
`;

export const Heading = styled.h4`
    color: #050505;
    font-family: Mallory-Book;
    font-size: 24px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    margin-bottom: 29px;
    text-transform: none;
`;

export const Link = styled.a`
    text-decoration: none;
`;

export const FullRange = styled.a`
    height: 40px;
    background-color: #070808;
    color: #FFFFFF;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 40px;
    text-align: center;
    display: inline-block;
    text-decoration: none;
    border: 1px solid rgb(7,8,8);
    margin: auto;
    padding: 0 40px;
    &:hover {
        background-color: rgb(255,255,255);
        color: rgb(7,8,8);
        border: 1px solid rgb(7,8,8);
    }
    @media (max-width: 767px){
        display: none;
    }
`;

export const FullRangeMobile = styled.a`
    height: 40px;
    background-color: #070808;
    color: #FFFFFF;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 40px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    padding: 0 40px;
    margin: auto;
    margin-top: 25px;
    &:hover {
        background-color: #FFFFFF;
        color:  #070808;
        border: solid 1px #070808;
    }
    @media (min-width: 768px){
        display: none;
    }
`;

export const ButtonContainer = styled.div`
    text-align: center;
    @media (max-width: 767px){
        max-width: 350px;
        margin: auto; 
    }
`;